<template>
  <main class="mx-auto">
    <HomeBanner />
    <HomeExpertise />
    <LazyHomeInnovation v-if="showAllComponents" />
    <LazyHomeClients v-if="showAllComponents" />
    <LazyHomeIdeas v-if="showAllComponents" />
    <!-- <div
      v-if="staging === 1"
      class="log-scroll fixed bottom-0 right-0 p-4 bg-gray-800 text-white rounded z-50"
    >
      {{ scrollY }} {{ staging }}
    </div> -->
  </main>
</template>

<script setup>
import { useGlobalStore } from '~/store/global'

const global = useGlobalStore()
const mainSeo = global.mainSeo
const mainBanner = global.mainBanner
// const staging = Number(useRuntimeConfig().public.IS_STAGING)

const showAllComponents = ref(false)

useJsonld({
  '@context': 'https://schema.org/',
  '@type': 'Organization',
  name: mainSeo?.attributes?.seo?.seo_title || 'Suitmedia',
  url: mainSeo?.attributes?.url || 'suitmedia.com',
  description:
    mainSeo?.attributes?.seo?.seo_description || 'Digital Agency Indonesia',
  image:
    mainSeo?.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png',
  email: 'contact(at)suitmedia.com',
  telephone: '+62 21 719 6877',
  legalName: 'PT Suitmedia Kreasi Indonesia',
  location: 'Jakarta, Bandung, Yogyakarta, Singapore',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Jakarta, Indonesia',
    postalCode: '12510',
    streetAddress: 'Jl. Pejaten Barat II No. 3A'
  }
})

useSeoMeta({
  title: mainSeo?.attributes?.seo?.seo_title || 'Suitmedia',
  ogTitle: mainSeo?.attributes?.seo?.seo_title || 'Suitmedia',
  description:
    mainSeo?.attributes?.seo?.seo_description || 'Digital Agency Indonesia',
  ogDescription:
    mainSeo?.attributes?.seo?.seo_description || 'Digital Agency Indonesia',
  ogImage:
    mainSeo?.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png',
  ogType: mainSeo?.attributes?.seo?.open_graph_type,
  ogSiteName: mainSeo?.attributes?.seo?.seo_title || 'Suitmedia',
  twitterTitle: mainSeo?.attributes?.seo?.seo_title || 'Suitmedia',
  twitterDescription:
    mainSeo?.attributes?.seo?.seo_description || 'Digital Agency Indonesia',
  twitterImage:
    mainSeo?.attributes?.seo?.image?.data?.attributes?.url ||
    mainBanner.attributes?.banner?.image?.data?.attributes?.url ||
    '/icon.png'
})

const expires = new Date()
expires.setTime(expires.getTime() + 1000 * 60 * 60 * 24) // 1 Day

global.darkTheme = useCookie('theme', {
  default: () => false,
  expires
})

const scrollY = ref(0)

const events = ['scroll', 'click', 'mousemove', 'touchmove']

const reveal = event => {
  showAllComponents.value = true
  // console.log({ event })
}

onMounted(() => {
  events.forEach(event =>
    document.addEventListener(event, reveal(event), {
      passive: true
    })
  )

  document.addEventListener('scroll', () => {
    scrollY.value = parseFloat(window.scrollY)
  })
})

onUnmounted(() => {
  events.forEach(event => document.removeEventListener(event, reveal(event)))
})

// lazy component scroll behaviour
</script>
